module.exports = __webpack_public_path__ + "img/likeIcon.2d2cb9a7.svg";